<template lang="pug">
  form(id="boost-form" v-if="payment !== null")
    div.md-form-group(:class="{'invalid':errors.has('boost_id')}")
      input.md-input(
      type="text"
      name="boost_id"
      v-model="payment.meta.boost_id"
      v-validate="'required'"
      data-vv-as="ID"
      :disabled="loading"
      ref="paymentName"
      )
      label Boost ID
      span.form-error-msg(v-show="errors.has('boost_id')") {{ errors.first('boost_id') }}

    div.md-form-group(:class="{'invalid':errors.has('boost_outlet_id')}")
      input.md-input(
      type="text"
      name="boost_outlet_id"
      v-model="payment.meta.boost_outlet_id"
      v-validate="'required'"
      data-vv-as="Outlet ID"
      :disabled="loading"
      )
      label Outlet ID
      span.form-error-msg(v-show="errors.has('boost_outlet_id')") {{ errors.first('boost_outlet_id') }}

    div.md-form-group(:class="{'invalid':errors.has('boost_pos_id')}")
      input.md-input(
      type="text"
      name="boost_pos_id"
      v-model="payment.meta.boost_pos_id"
      v-validate="'required'"
      data-vv-as="POS ID"
      :disabled="loading"
      )
      label POS ID
      span.form-error-msg(v-show="errors.has('boost_pos_id')") {{ errors.first('boost_pos_id') }}

    div.md-form-group.p-t-0
      label.multiselect-label Applicable outlets
      multiselect(
      name="outlets"
      v-model="payment.outlets"
      :options="outletList"
      placeholder="Type to search"
      label="name"
      :multiple="true"
      :loading="outletList.length === 0"
      :disabled="loading"
      :clear-on-select="false"
      :close-on-select="false"
      :hide-selected="true"
      track-by="id"
      )
      span.md-input-msg Leave empty if applicable to all outlets.
</template>

<script>
import FormMixin from '../form-mixin';

export default {
    mixins: [FormMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: 'Boost',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: 'boost',
                meta: {},
                outlets: [],
            }),
        },
    },

    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, ['id', 'meta']);

            return Object.assign(payment, {
                name: 'Boost',
                type: 4,
                preset_amount: null,
                require_reference: true,
                source: 'boost',
                outlets: this.payment.outlets.map(obj => obj.id),
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/boost-form.vue